export const API_HOST = import.meta.env.VITE_API_URL !== undefined ? import.meta.env.VITE_API_URL : "http://localhost:8000"

export const STORAGE_KEY = "ai_tutor_auth_token"
